<template>
  <el-dialog title="策略详情"
             :close-on-click-modal="false"
             append-to-body
             v-bind="$attrs"
             v-on="$listeners">
    <el-form ref="formRef"
             :model="formData"
             label-width="80px"
             inline
             size="small"
             disabled>
      <el-card shadow="never">
        <template #header>
          <div class="card-header">基础信息</div>
        </template>
        <div class="container">
          <div class="content">
            <el-form-item label="业务类型"
                          prop="type">
              <el-select v-model="formData.type">
                <el-option v-for="item in tacticsTypeOptions"
                           :key="item.value"
                           v-bind="item" />
              </el-select>
            </el-form-item>
            <el-form-item label="策略名称"
                          prop="name">
              <el-input v-model="formData.name"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-card>

      <el-card style="margin-top: 30px"
               shadow="never">
        <template #header>
          <div class="card-header">策略配置规则</div>
        </template>
        <div class="container">
          <div class="title">策略参数</div>
          <div class="content">
            <el-form-item label="渠道">
              <el-radio-group v-model="isShowSelectChannelInput">
                <el-radio :label="false">全部渠道</el-radio>
                <el-radio :label="true">指定渠道</el-radio>
              </el-radio-group>
            </el-form-item>
            <div>
              <el-form-item v-if="isShowSelectChannelInput"
                            label="指定渠道"
                            prop="appid">
                <el-input type="textarea"
                          style="width: 510px;"
                          :rows="4"
                          :value="channelNameText"
                          @focus="isSelectChannel = true" />
              </el-form-item>
            </div>
          </div>

          <div class="container">
            <div class="title">策略结果</div>
            <div class="subtitle">请选择符合上述参数条件时匹配的策略</div>
            <div class="content">
              <div>
                <el-form-item label="结果类型">
                  <el-radio-group v-model="formData.resultType">
                    <el-radio :label="1">单一结果</el-radio>
                    <el-radio :label="2">流量权重</el-radio>
                    <el-radio :label="3">次数限制</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <template v-for="(item, index) in formData.configurationValue">
                <!-- 单一结果 -->
                <el-form-item v-if="formData.resultType === 1"
                              label="策略结果"
                              :prop="`configurationValue.${index}.id`"
                              :key="item">
                  <el-select v-model="formData.configurationValue[index].id"
                             :key="index">
                    <el-option v-for="item in tacticsResultOptions"
                               :key="item.value"
                               v-bind="item" />
                  </el-select>
                </el-form-item>
                <!-- 单一结果 -->
                <!-- 流量权重 -->
                <div v-if="formData.resultType === 2"
                     :key="item">
                  <el-form-item label="策略结果"
                                :prop="`configurationValue.${index}.id`">
                    <el-select v-model="formData.configurationValue[index].id">
                      <el-option v-for="item in tacticsResultOptions"
                                 :key="item.value"
                                 v-bind="item" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="权重"
                                :prop="`configurationValue.${index}.rate`">
                    <el-input v-model="formData.configurationValue[index].rate"
                              placeholder="0- 100，不填表示100"
                              min="1"
                              max="100">
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </div>
                <!-- 流量权重 -->
                <!-- 次数限制 -->
                <div v-if="formData.resultType === 3"
                     :key="item">
                  <el-form-item label="策略结果"
                                :prop="`configurationValue.${index}.id`">
                    <el-select v-model="formData.configurationValue[index].id">
                      <el-option v-for="item in tacticsResultOptions"
                                 :key="item.value"
                                 v-bind="item" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="次数/天"
                                :prop="`configurationValue.${index}.times`">
                    <el-input v-model="formData.configurationValue[index].times"
                              placeholder="1-999999" />
                  </el-form-item>
                </div>
                <!-- 次数限制 -->
              </template>
            </div>
          </div>
        </div>
      </el-card>
    </el-form>
  </el-dialog>
</template>

<script>
import ChannelPopups from "@/components/channel-popups";
import { getDetail } from "@/api/resource/rabbittactics";
import tacticsResultList from "@/config/tacticsResultConfig"

export default {
  components: { ChannelPopups },
  props: {
    id: String
  },
  data () {
    return {
      isSelectChannel: false,
      isShowSelectChannelInput: false,
      channelNameText: "",
      tacticsTypeOptions: [
        { value: 1, label: "云桌面策略" },
        { value: 2, label: "云镜像策略" },
        { value: 3, label: "人脸认证服务" },
        { value: 4, label: "会议RTC服务" }
      ],
      formData: {
        id: "",
        resultType: 1,
        appid: "",
        name: "",
        type: 1,
        configurationValue: []
      }
    };
  },
  computed: {
    tacticsResultOptions () {
      const options = {
        1: [
          { value: 3, label: "腾讯云" },
          { value: 2, label: "阿里云" },
          { value: 1, label: "威尔云" }
        ],
        2: [
          // { value: 4, label: "游密" },
          // { value: 5, label: "即构" }
          ...tacticsResultList
        ],
        3: [
          { value: 7, label: "腾讯" }
        ],
        4: [
          { value: 0, label: "即构RTC+即构IM" },
          { value: 1, label: "网易RTC+网易IM" },
          { value: 2, label: "腾讯RTC+网易IM" },
          { value: 3, label: "即构RTC+网易IM" }
        ]
      };
      return options[this.formData.type].map(item => {
        item.disabled = this.formData.configurationValue.some(
          v => v.id === item.value
        );
        return item;
      });
    }
  },
  watch: {
    "$attrs.visible" (newV) {
      if (newV) {
        getDetail(this.id).then(res => {
          const data = res.data.data;
          for (const key in this.formData) {
            if (key === "configurationValue") {
              this.formData[key] = JSON.parse(data[key]);
            } else {
              this.formData[key] = data[key];
            }
          }
          this.isShowSelectChannelInput = !!this.formData.appid;
          this.channelNameText = data.appName;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-card__header {
  background: #f5f7fa;
}

.card-header {
  height: 40px;
  line-height: 40px;
}

.container {
  .title {
  }

  .subtitle {
    margin-top: 15px;
    font-size: 12px;
    color: #909399;
  }

  .content {
    padding: 20px 30px 0 30px;
  }
}
</style>
